import React from 'react';

// SMK demerit-point thresholds → label + colour.
// Ordered from worst → best; the first matching threshold wins.
const SMK_LEVELS = [
  { min: 14, color: '#ef4444', label: 'Kritikal - Lesen Dalam Bahaya' },
  { min: 7,  color: '#f97316', label: 'Bahaya - Kursus Wajib Diperlukan' },
  { min: 1,  color: '#f59e0b', label: 'Awas - Amaran Diberikan' },
  { min: 0,  color: '#22c55e', label: 'Rekod Bersih - Tiada Kesalahan' },
];

const levelFor = (points) => SMK_LEVELS.find((lvl) => points >= lvl.min);

export const SMKMeter = ({ points }) => {
  const max = 20;
  const pct = Math.min((points / max) * 100, 100);
  const { color, label } = levelFor(points);
  return (
    <div data-testid="smk-meter">
      <div className="flex items-center justify-between mb-1">
        <span className="text-xs text-gray-500">0 mata</span>
        <span className="font-bold text-sm" style={{ color }}>{points} / {max} mata</span>
        <span className="text-xs text-gray-500">20 mata</span>
      </div>
      <div className="w-full rounded-full h-3" style={{ backgroundColor: '#e5e7eb' }}>
        <div
          className="h-3 rounded-full transition-all duration-500"
          style={{ width: `${pct}%`, backgroundColor: color }}
        />
      </div>
      <div className="mt-1 text-xs" style={{ color }}>{label}</div>
    </div>
  );
};

export default SMKMeter;
